import React, { useEffect, useState, useCallback, useMemo } from 'react';
import './_cardDefaultCF.scss';
import ApiGo from '../../actions/ApiGo';
import '../../actions/dataHandler_dateFormat';
import { useTranslation } from "react-i18next";
import ResidentSetting from '../residents/ResidentSetting';
// ⌬ 1.3 Redex
import dh_alert from '../../actions/dataHandler_alert';
import comm_imgs from '../../comm_imgs';
import HistoryRecord from '../residents/historyRecord/HistoryRecord';
import { RR } from '../residents/historyRecord/HISVital/SVGRRHR';
import { DF } from '../dashboard/DashFunction';
import AlertCancel from '../popUp/AlertCancel';
import { useDispatch, useSelector } from 'react-redux';
import ConfigHandler from '../../actions/ConfigHandler';


const CardDefault = React.memo((props) => {
    const isVital = ConfigHandler.isVital;
    const isReadOnly = ConfigHandler.isReadOnly();
    const [historyPanel, setHistoryPanel] = useState(false);
    function toggleHisPanel() { setHistoryPanel(!historyPanel) }

    const store_resident_withAlerts = useSelector(state => state.store_alerts.residents_with_alerts)
    const store_alerts = useSelector(state => state.store_alerts.alert_array)

    const [editPanel, setEditPanel] = useState(false);
    function toggleEditPanel() { setEditPanel(!editPanel) }


    /* i18n 相關 */
    const { t } = useTranslation();

    /* 此 component 資本資料 */
    const mac_left = props.data.data ? props.data.data.mac : "";
    const bed_id = props.data.data ? props.data.data.bed_id : null;
    const resident_id = props.data ? props.data.data.id : null;
    /* 讀取mqtt值 */
    const mos = props.mos
    const mos_rr = mos?.rr;
    const mos_events = mos?.events;

    /* Api 資料 */
    const apiData = props.data.data;
    const card_type = props.data.card_type
    const [apiData_SQ, setApiData_SQ] = useState(null);
    const [breathTemp, setBreathTemp] = useState(null);

    const [alertCancelModalShow, setAlertCancelModalShow] = useState(false);
    // const [alertShow, setAlertShow] = useState(false);
    // const [alertContent, setAlertContent] = useState(null);


    const hasAlerts = useMemo(() => {
        const set = new Set(store_resident_withAlerts);
        return resident_id != null && set.has(resident_id);
    }, [store_resident_withAlerts, resident_id]);

    const alertsForResident = useMemo(() => {
        if (!resident_id) return [];
        return store_alerts.filter((a) => a.resident_id === resident_id);
    }, [store_alerts, resident_id]);


    const alertMeta = useMemo(() => dh_alert(apiData.alert_priority, apiData.alert_type_id),
        [apiData.alert_priority, apiData.alert_type_id]);


    // useEffect(() => {
    //     let _index = store_resident_withAlerts.indexOf(resident_id)
    //     let _a = store_alerts.filter(res => res.resident_id === resident_id)

    //     console.log("alertContent", _a)
    //     if (_index === -1) {
    //         setAlertShow(false)
    //     } else {
    //         setAlertShow(true);
    //     }
    //     setAlertContent(_a);
    // }, [store_resident_withAlerts, store_alerts, resident_id]);


    const toggleAlertCancel = useCallback(() => {
        if (!hasAlerts) {
            setAlertCancelModalShow(false);
            return;
        }
        setAlertCancelModalShow((v) => !v);
    }, [hasAlerts]);
    // useEffect(() => {

    //     console.log("alertContent", alertContent);
    //     console.log("alertShow", alertShow);
    //     console.log("alertCancelModalShow", alertCancelModalShow);

    // }, [alertContent, alertShow, alertCancelModalShow])

    // // NOTE: GET - Breath
    // useEffect(() => {
    //     ApiGo.getBreath(String(resident_id))
    //         .then(res => {
    //             if (res.breaths[0] === null || res.breaths[0] === undefined) { return 0 }
    //             // setApiData_Breath(res.breaths[0].observation)
    //         })
    //         .catch(() => { })
    // }, [resident_id]);

    // // NOTE: GET - Breath
    // useEffect(() => {
    //     if (card_type !== "aidc") { return }
    //     ApiGo.getBedStatus2ui(String(bed_id))
    //         .then(res => {
    //             // setBedState2ui(res)
    //         })
    //         .catch(() => { })
    // }, [bed_id, card_type]);

    // // NOTE: GET - Sleep Quality
    // useEffect(() => {
    //     const d = (new Date());
    //     d.setDate(d.getDate())
    //     const ytd = String(d.Format("yyyy-MM-dd"))
    //     function fetchData() {
    //         ApiGo.getSleepQuality_ByResident(resident_id, ytd, ytd)
    //             .then((res) => {
    //                 const temp_SE = parseFloat(res.sleep_qualities[0].SE).toFixed(2);
    //                 setApiData_SQ(temp_SE)
    //             })
    //             .catch(() => { })
    //     }
    //     if (apiData_SQ === null) { fetchData(); }
    // }, [apiData_SQ, resident_id]);

    // useEffect(() => {
    //     let default_IA = identifyAlert(store_resident_withAlerts, resident_id, true, store_alerts)
    //     setIA(default_IA);


    // }, []);

    // useEffect(() => {

    //     if (mos_events && mos_events.bed_id === bed_id) {
    //         console.log("CardDefault: mos_event", mos_events, "bed_id:", bed_id);

    //         if (mos_events.bed_state == 212 || mos_events.bed_state == 211) {
    //             let resolvedIA = identifyAlert(store_resident_withAlerts, resident_id, false, store_alerts)
    //             setIA(resolvedIA);
    //         } else {
    //             let newIA = identifyAlert(store_resident_withAlerts, resident_id, true, store_alerts)
    //             setIA(newIA);
    //         }
    //     }
    // }, [mos_events]);

    //日期轉換
    const formatTimestamp = (timestamp) => {
        if (!timestamp) return { date: "-", time: "" };

        if (isVital) {
            if (timestamp.includes('T')) {
                const time = timestamp.slice((timestamp.indexOf("T") + 1), timestamp.lastIndexOf(".")) ?? "-";
                return { date: "", time };
            } else {
                return { date: "", time: timestamp };
            }
        } else {
            const date = new Date(timestamp);
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            const formattedDate = `${date.getDate().toString().padStart(2, '0')} ${months[date.getMonth()]} ${date.getFullYear().toString().slice(-2)}`;
            const formattedTime = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
            return { date: formattedDate, time: formattedTime };
        }
    }
    return (
        <>
            {alertCancelModalShow && hasAlerts ?
                // content={identifyAlert(store_resident_withAlerts, resident_id, alertCancel, store_alerts).content}
                <AlertCancel
                    hide={toggleAlertCancel}
                    content={alertsForResident}
                    resident={apiData}
                />
                : null}
            {/* <div className="fullbody"> */}
            <div className="cardDefaultCF forDashCard MWG" onClick={toggleAlertCancel}>
                {/* <div className={`fullcard pos-a z-2 ${identifyAlert(store_resident_withAlerts, resident_id, true, store_alerts).open? 'emer':""}`}> */}
                <div className={`fullcard  ${isVital || "fx-d-c cspar"} ${hasAlerts ? 'emer' : ""}`}>
                    <div className="cardUpper ">
                        {/* <div className="info">陳爺爺</div> */}
                        <div className="d-flex" style={{ overflow: "hidden" }}>
                            <div className={`w-50 info font-l font-bold text-color-black ta-c`} style={{ minWidth: 0, overflow: "hidden", wordBreak: "break-all", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical" }}>
                                {apiData.room_name}{DF.abbreviate(apiData.first_name, 12)}
                            </div>
                            {/* <div className="w-50 info font-bold ta-c">{DF.abbreviate(apiData.first_name, 'all')}</div> */}
                            <div className={`w-50 info font-l font-bold text-color-black ta-c`}>{DF.abbreviate(apiData.last_name, 5)}</div>
                            {/* <div className="w-50 info font-bold ta-c">{DF.abbreviate(apiData.last_name, 5)}</div> */}
                        </div>
                        <div className="d-flex upper">
                            {isVital ? <>
                                {/* 有vital */}
                                <div className="fx-d-c fx-cspar w-50 upperLeft ta-c" >
                                    {alertsForResident?.length !== undefined && alertsForResident?.length > 0 ?
                                        <div className='little_alert_tag fx-ccc font-ml'>
                                            {alertsForResident?.length}
                                        </div>
                                        : null}
                                    <img className="upperPic"
                                        src={alertMeta.img}
                                        alt={alertMeta.msg} />
                                    <div className="info fx-center">
                                        <span>{formatTimestamp(apiData.alert_timestamp).date}</span>
                                        <span>{formatTimestamp(apiData.alert_timestamp).time}</span>
                                    </div>
                                </div>
                            </> : <>
                                <div className="fx-cspev w-100 upperLeft ta-c" >
                                    {alertsForResident?.length !== undefined && alertsForResident?.length > 0 ?
                                        <div className='little_alert_tag fx-ccc font-ml'>
                                            {alertsForResident?.length}
                                        </div>
                                        : null}
                                    <div className='w-50'>
                                        <img className="upperPicNoVital"
                                            src={alertMeta.img}
                                            alt={alertMeta.msg} />
                                    </div>
                                    <div className="info fx-d-c gap6 font-ms w-50">
                                        <span>{formatTimestamp(apiData.alert_timestamp).date}</span>
                                        <span>{formatTimestamp(apiData.alert_timestamp).time}</span>
                                    </div>
                                </div>
                            </>}
                            {/* 沒有vital */}
                            {isVital &&
                                <div className="w-50 fx-ccc upperRight">
                                    {/* 呼吸次數 */}
                                    <div className="unit fx-d-c fx-ccc pad-10 l RRonly fw600 ">
                                        {/* <div className='fx-ccc vital font-xxl circle'>20</div> */}
                                        <div className='fx-ccc vital font-xxl circle'>{DF.vital_count(apiData, mos_rr, mac_left, breathTemp, setBreathTemp)}</div>
                                        <div className='fx-ccc BPM'>BPM</div>
                                    </div>
                                    <div className="pos-a icon_trans"><RR type={"icon_pic"} /></div>
                                </div>
                            }
                        </div>
                    </div>

                    {/* <div className="divider" /> */}

                    <div className="cardBottom" onClick={e => { e.stopPropagation() }}>
                        {/* 解除告緊鈕: 暫時用不到先註解 */}
                        {/* <div className="col bottomButton fx-center">
                        <img className="" src={comm_imgs.ICONA_3} alt={t('GLOBAL.BED_STATE.LEVEL3')} />
                    </div> */}

                        {/* 開啟歷史記錄 */}
                        <div className={`${isReadOnly ? 'w-100' : 'w-50'} bottomButton fx-center image-toggle cursor pt ${alertMeta.level === "emergency" ? "emer" : ""}`}
                            onClick={toggleHisPanel}>
                            <img className="" src={comm_imgs.ICONB_2} alt={t("HISTORY_RECORD.HISTORY_RECORD")} />
                            <img className="" src={comm_imgs.ICONB_1} alt={t("HISTORY_RECORD.HISTORY_RECORD")} />
                        </div>

                        {/* 開啟設定 */}
                        {/* <div className="col bottomButton fx-center image-toggle cursor pt" */}
                        {
                            isReadOnly ? null : <div className={`w-50 bottomButton fx-center image-toggle cursor pt ${alertMeta.level === "emergency" ?
                                "emer"
                                : alertMeta.level === "warning" ?
                                    "warn" : ""
                                }`
                            }
                                onClick={toggleEditPanel}>
                                <img className="" src={comm_imgs.ICONC_2} alt={t("RESIDENTS.ENTER")} />
                                <img className="" src={comm_imgs.ICONC_1} alt={t("RESIDENTS.ENTER")} />
                            </div>
                        }


                        {/* 彈出視窗設定 */}
                        {editPanel ? <ResidentSetting hide={toggleEditPanel} data={apiData} page={0} /> : null}
                        {/* 彈出視窗歷史紀錄 */}
                        {historyPanel ? <HistoryRecord hide={toggleHisPanel} data={apiData} /> : null}
                    </div>
                </div>
            </div>
            {/* </div> */}
        </>
    )
})

export default CardDefault;


// let IA = identifyAlert(store_resident_withAlerts, resident_id, true, store_alerts)

// export function identifyAlert(store = [], id = "", cancel, alerts) {
//     let _index = store.indexOf(id)
//     if (!cancel) { return { open: false, content: {} } }
//     if (_index === -1) { return { open: false, content: {} } }
//     let _a = alerts.filter(res => res.resident_id === id)
//     return { open: true, content: _a , mac_id: _a[0]?.mac_id || "" }
// }
